export default "/images/angle-down.svg?1789433f65f3dfa69b8561136e521093";